import React from "react";
import { PHARMACY_STOCK_PLACEHOLDER } from "@/services/pharmacyLaneService.js";

export default function StockThumb({
  src,
  alt = "",
  size = "row",
  className = "",
}) {
  const [failedSrc, setFailedSrc] = React.useState("");
  const effectiveSrc = failedSrc === src ? PHARMACY_STOCK_PLACEHOLDER : src;
  const isPlaceholder = !effectiveSrc || effectiveSrc === PHARMACY_STOCK_PLACEHOLDER;
  const sizeClass = size === "preview" ? "h-[56px] w-[56px]" : "h-[44px] w-[44px]";

  React.useEffect(() => {
    setFailedSrc("");
  }, [src]);

  return (
    <div
      className={[
        "relative flex items-center justify-center overflow-hidden rounded-[8px]",
        "border border-[rgba(24,50,119,0.10)] bg-[rgb(var(--clr-surface-cont-low))]",
        "shadow-[0px_0px_0px_1px_rgba(24,50,119,0.10),0px_1.5px_0px_-0.5px_rgba(26,27,35,0.06)]",
        sizeClass,
        className,
      ].join(" ")}
    >
      <img
        src={effectiveSrc || PHARMACY_STOCK_PLACEHOLDER}
        alt={alt}
        className={[
          "h-full w-full rounded-[8px]",
          isPlaceholder ? "object-contain p-2" : "object-cover",
        ].join(" ")}
        onError={() => setFailedSrc(src || PHARMACY_STOCK_PLACEHOLDER)}
      />
    </div>
  );
}
